module.exports = __webpack_public_path__ + "assets/9f5d79563f5a68c415e1c99ccc0f222f.png";